import { APIPOST, APIGET, APIDELETE } from '../utils/apiHelper';
import { PROFILE_ADD, PROFILE_DELETE } from './actions.type';

const actions = {
  async [PROFILE_ADD](context, profileDetails) {
    try {
      const response = await APIPOST('profile/add', profileDetails);
      if (response.error) {
        throw response;
      } else {
        return response;
      }
    } catch (err) {
    }
  },
  async [PROFILE_DELETE](context, profileId) {
    try {
      const response = await APIDELETE('profile/', profileId);
      if (response.error) {
        throw response;
      } else {
        return response;
      }
    } catch (err) {
    }
  },
};

export default { actions };
